import { cn } from '../../lib/cn';
import { Card, StatusChip } from '../ui';
import type { TimelineEvent } from '../../workspaceshell/framework';

type Props = {
  events?: TimelineEvent[];
  title?: string;
  className?: string;
};

export function TimelinePanel({ events = [], title = 'Timeline', className }: Props) {
  return (
    <Card className={cn(className)} padding="sm">
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">{title}</p>
      <ul className="mt-3 space-y-3">
        {events.map((event) => (
          <li key={event.id} className="border-l-2 border-slate-200 pl-3 dark:border-slate-700">
            <div className="flex flex-wrap items-center gap-2">
              <StatusChip status={event.type} />
              {event.module && <span className="text-[10px] text-slate-400">{event.module}</span>}
            </div>
            <p className="mt-1 text-sm font-medium text-slate-900 dark:text-slate-100">{event.title}</p>
            {event.description && (
              <p className="text-xs text-slate-500">{event.description}</p>
            )}
            <p className="mt-1 text-[10px] text-slate-400">
              {event.actor && `${event.actor} · `}
              {new Date(event.timestamp).toLocaleString()}
            </p>
          </li>
        ))}
      </ul>
    </Card>
  );
}
